import React from 'react'
import PanelMemberTemplate from '../../components/PanelMemberTemplate'
import { Dana_data } from '../../assets'


const DanaYork = () => {
  return (
    <>
    <PanelMemberTemplate {...Dana_data}/>
    </>
  )
}

export default DanaYork
